import { Component, Event, EventEmitter, getAssetPath, h, Host, Prop } from '@stencil/core';

import wcShared from '@web-components/shared';

@Component({
  tag: 'chat-message-rating-component',
  styleUrl: 'chat-message-rating-module.scss',
  shadow: true,
})
export class ModuleChatMessageRating {
  @Prop() readonly message: IWCChatMessage;
  @Prop() readonly lastMessage: { total: number; index: number };

  @Event() selectValue: EventEmitter<{ value: string; type: string }>;

  private submit(item: string, type = 'rating_reply') {
    this.selectValue.emit({ value: item, type });
  }

  render() {
    if (this.message?.type === 'rating') {
      return (
        <Host>
          <div class="rating-title">{this.message?.title}</div>
          <div class="rating-action">
            {(this.message?.action as IWCChatMessageValue[])?.map((item) => {
              if (item.value === 1) {
                return (
                  <button
                    type="button"
                    class="rating-action--positif"
                    onClick={() => {
                      this.submit(item.value);
                    }}
                    disabled={this.lastMessage?.total !== this.lastMessage?.index}
                  >
                    <img
                      src={getAssetPath('./../assets/icons/like.svg')}
                      alt={wcShared.translate('Vote positif')}
                    />
                  </button>
                );
              } else {
                return (
                  <button
                    type="button"
                    class="rating-action--negatif"
                    onClick={() => this.submit(item.value)}
                    disabled={this.lastMessage?.total !== this.lastMessage?.index}
                  >
                    <img
                      src={getAssetPath('./../assets/icons/like.svg')}
                      alt={wcShared.translate('Vote negatif')}
                    />
                  </button>
                );
              }
            })}
          </div>
        </Host>
      );
    } else if (this.message?.type === 'rating_reply') {
      return (
        <Host>
          {this.message?.title === 1 ? (
            <div class="rating-reply rating-action--positif">
              <img
                src={getAssetPath('./../assets/icons/like.svg')}
                alt={wcShared.translate('Vote positif')}
              />
            </div>
          ) : (
            <div class="rating-reply rating-action--negatif">
              <img
                src={getAssetPath('./../assets/icons/like.svg')}
                alt={wcShared.translate('Vote negatif')}
              />
            </div>
          )}
        </Host>
      );
    }
  }
}
